import { CountUp } from 'countup.js';

export const providers = [
  {
    name: 'Blue Bikes',
    city: 'Boston',
    url: 'www.bluebikes.com/system-data',
    urlShort: 'bluebikes.com',
    logo: '/img/logos/Blue-Bikes-SM-logo_p_WEB_v2.svg',
    logoHeight: '26px',
    location: { lat: 42.3601, lng: -71.0589 },
    sql: {
      table: 'trips_bluebike_boston',
      startDateField: 'starttime',
      endDateField: 'stoptime',
      startTimeField: 'starttime',
      endTimeField: 'stoptime',
    }
  },
  {
    name: 'Citibike',
    city: 'NYC',
    url: 'www.citibikenyc.com/system-data',
    urlShort: 'citibikenyc.com',
    logo: '/img/logos/Citi-Bike-provided-by-Lyft-Positive-170x57px.svg',
    logoHeight: '36px',
    location: { lat: 40.7128, lng: -74.0060 },
    sql: {
      table: 'trips_citibike_nyc',
      startDateField: 'starttime',
      endDateField: 'stoptime',
      startTimeField: 'starttime',
      endTimeField: 'stoptime',
    }
  },
  {
    name: 'Capital Bikeshare',
    city: 'DC',
    url: 'www.capitalbikeshare.com/system-data',
    urlShort: 'capitalbikeshare.com',
    logo: '/img/logos/CaBi-logo_red.svg',
    logoHeight: '32px',
    location: { lat: 38.9072, lng: -77.0369 },
    sql: {
      table: 'trips_capitalbikeshare_dc',
      startDateField: 'startdate',
      endDateField: 'enddate',
      startTimeField: 'startdate',
      endTimeField: 'enddate',
    }
  },
  {
    name: 'Divvy Bikes',
    city: 'Chicago',
    url: 'www.divvybikes.com/system-data',
    urlShort: 'divvybikes.com',
    logo: '/img/logos/Divvy-Header-Logo.svg',
    logoHeight: '26px',
    location: { lat: 41.8781, lng: -87.6298 },
    sql: {
      table: 'trips_divvy_chicago',
      startDateField: '',
      endDateField: '',
      startTimeField: '',
      endTimeField: '',
    }
  },
  {
    name: 'Biketown',
    city: 'Portland',
    url: 'www.biketownpdx.com/system-data',
    urlShort: 'biketownpdx.com',
    logo: '/img/logos/Biketown-Logo.svg',
    logoHeight: '23px',
    location: { lat: 45.5051, lng: -122.6750 },
    sql: {
      table: 'trips_biketown_portland',
      startDateField: 'startdate',
      endDateField: 'enddate',
      startTimeField: 'starttime',
      endTimeField: 'endtime',
    }
  },
  {
    name: 'Metro Bikeshare',
    city: 'LA',
    url: 'bikeshare.metro.net/about/data',
    urlShort: 'metro.net',
    logo: '/img/logos/bikeshre-logo.png',
    logoHeight: '26px',
    location: { lat: 34.0522, lng: -118.2437 },
    sql: {
      table: 'trips_bikeshare_la',
      startDateField: 'start_time',
      endDateField: 'end_time',
      startTimeField: 'start_time',
      endTimeField: 'end_time',
    }
  },
];

export const monthRefs = [
  { abbr: "jan", no: 1, name: "January", days: 31, dayscum: 31},
  { abbr: "feb", no: 2, name: "February", days: 28, dayscum: 59},
  { abbr: "mar", no: 3, name: "March", days: 31, dayscum: 90},
  { abbr: "apr", no: 4, name: "April", days: 30, dayscum: 120},
  { abbr: "may", no: 5, name: "May", days: 31, dayscum: 151},
  { abbr: "jun", no: 6, name: "June", days: 30, dayscum: 181},
  { abbr: "jul", no: 7, name: "July", days: 31, dayscum: 212},
  { abbr: "aug", no: 8, name: "August", days: 31, dayscum: 243},
  { abbr: "sep", no: 9, name: "September", days: 30, dayscum: 273},
  { abbr: "oct", no: 10, name: "October", days: 31, dayscum: 304},
  { abbr: "nov", no: 11, name: "November", days: 30, dayscum: 334},
  { abbr: "dec", no: 12, name: "December", days: 31, dayscum: 365}
]

export function num1K1MFormatter (num, decPlaces = 0) {
  if (Math.abs(num) > 999999) {
    return Math.sign(num)*((Math.abs(num)/1000000).toFixed(decPlaces)) + 'M'
  }
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(decPlaces)) + 'K' : Math.sign(num)*Math.abs(num)
}

export function num1K1MParts (num, decPlaces = 0, decPlacesM = 0) {
  if (Math.abs(num) > 999999) {
    return { num: Math.sign(num)*((Math.abs(num)/1000000).toFixed(decPlacesM)), suffix: 'M' }
  }
  return Math.abs(num) > 999 ? { num: Math.sign(num)*((Math.abs(num)/1000).toFixed(decPlaces)), suffix: 'K' } : { num: Math.sign(num)*Math.abs(num).toFixed(decPlaces) }
}

export function arrayToObject (array, keyField) {
  array.reduce((obj, item) => {
    obj[item[keyField]] = item
    return obj
  }, {});
}

export function ioRevealInit (container) {
  // First we select the element we want to target
  const targets = container.querySelectorAll('.ioreveal');

  // Next we want to create a function that will be called when that element is intersected
  function handleIntersection (entries) {
    // The callback will return an array of entries, even if you are only observing a single item
    let countUpIndex = 0
    let countUpCompleted = {}
    entries.map((entry) => {
      if (entry.isIntersecting) {
        // console.log("handleIntersection -> entry", entry.target)
        const aniClass = entry.target.getAttribute('data-anicss')
        if (!entry.target.classList.contains(aniClass)) {
          entry.target.classList.add(aniClass)
        }
        const countUps = entry.target.querySelectorAll('[data-countup]')
        countUps.forEach((el) => {
          // console.log("handleIntersection -> el", el)
          // TODO: add check to see if el already had run the countup animation
          const options = { decimalPlaces: el.getAttribute('data-countup-decplaces') || 1 }
          countUpIndex++
          setTimeout(() => (new CountUp(el, el.getAttribute('data-countup'), options)).start(), 500*countUpIndex);
        })
      }
    });
  }

  // Next we instantiate the observer with the function we created above.
  // This takes an optional configuration object
  const observer = new IntersectionObserver(handleIntersection);

  // Finally start observing the target elements
  targets.forEach(function(target) {
    observer.observe(target);
  })

}

export function ioSectionsInit (sectionInViewRefObj) {
  const targets = document.querySelectorAll('section');
  const observer = new IntersectionObserver(entries => {
    let firstInView = false
    entries.map((entry, i) => {
      if (entry.isIntersecting) {
        let yPosition = entry.boundingClientRect.y
        // sectionInViewRefObj.target = entry.target
        if (!firstInView) {
          // sectionInViewRefObj.target = entry.target
          // if (entry.target === document.querySelector('section') && yPosition > 50 && yPosition < 500) { // if first section
          if (yPosition > 50 && yPosition < document.querySelector('section').offsetHeight) { // if first section
            sectionInViewRefObj.target = entry.target.nextElementSibling //.nextSibling.nextSibling
            // console.log(" ----- -> entry.target.nextElementSibling", entry.target, entry.target.nextElementSibling)
          } else if (entry.target === document.querySelector('section')) {
            sectionInViewRefObj.target = entry.target.nextElementSibling
          }
          // sectionInViewRefObj.no = entry
          // console.log("ioSectionsInit -> entry.target.nextSibling", entry.target.nextElementSibling)
          // console.log("ioSectionsInit -> sectionInViewRefObj.target", sectionInViewRefObj.target)
        }
        // firstInView = true
      }
      // console.log("****  ealInit -> entry", i, entry.boundingClientRect.y)
      // console.log("****  ealInit -> entry", i, entry.boundingClientRect.y, entry.target, document.querySelector('section'))
    });
  }, { threshold: [0.05] });
  targets.forEach(target => observer.observe(target));
}